var _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenWithSideLineWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2922 18.2831H11.248C10.903 18.2831 10.623 18.0031 10.623 17.6581C10.623 17.3131 10.903 17.0331 11.248 17.0331H17.2922C17.6372 17.0331 17.9172 17.3131 17.9172 17.6581C17.9172 18.0031 17.6372 18.2831 17.2922 18.2831Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15002_154743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 15,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 2.50012H15.9841V18.2831H1.66699V2.50012Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15002_154743)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9256 4.18066L3.07972 13.9932C2.93722 14.1715 2.88472 14.4015 2.93722 14.6223L3.50472 17.0265L6.03722 16.9948C6.27805 16.9923 6.50055 16.8848 6.64805 16.7015C9.32889 13.3473 14.4397 6.95232 14.5847 6.76482C14.7214 6.54316 14.7747 6.22982 14.7031 5.92816C14.6297 5.61899 14.4372 5.35649 14.1597 5.18899C14.1006 5.14816 12.6964 4.05816 12.6531 4.02399C12.1247 3.60066 11.3539 3.67399 10.9256 4.18066ZM3.01139 18.2832C2.72222 18.2832 2.47055 18.0848 2.40305 17.8023L1.72055 14.9098C1.57972 14.3107 1.71972 13.6923 2.10389 13.2123L9.95389 3.39399C9.95722 3.39066 9.95972 3.38649 9.96305 3.38316C10.8239 2.35399 12.3806 2.20232 13.4306 3.04482C13.4722 3.07732 14.8664 4.16066 14.8664 4.16066C15.3731 4.46232 15.7689 5.00149 15.9189 5.63982C16.0681 6.27149 15.9597 6.92316 15.6122 7.47399C15.5864 7.51482 15.5639 7.54982 7.62389 17.4832C7.24139 17.9598 6.66805 18.2373 6.05222 18.2448L3.01972 18.2832H3.01139Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5198 9.73732C13.3865 9.73732 13.2532 9.69482 13.139 9.60815L8.59568 6.11815C8.32234 5.90815 8.27068 5.51648 8.48068 5.24148C8.69151 4.96815 9.08317 4.91732 9.35734 5.12732L13.9015 8.61648C14.1748 8.82648 14.2265 9.21899 14.0157 9.49315C13.8932 9.65315 13.7073 9.73732 13.5198 9.73732Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenWithSideLineWhite);
export default __webpack_public_path__ + "static/media/pen-with-side-line--white.48fc9cb8b66a38797d31a837d5368f7c.svg";
export { ForwardRef as ReactComponent };